;(function () {
  'use strict';

  let angular = window.angular;

  OrganizationEditController.$inject = ['$scope', 'Admin', 'Var', 'AppUtils'];

  angular
    .module('app')
    .component('accountOrganizationEdit', {
      template:'<form name="$ctrl.updateForm" class="validate" novalidate ng-hide="$ctrl.saving"><div class="modal-header"><button type="button" class="close" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span translate>form.actions.edit</span> <span translate>entities.organization.modelName</span></div><div class="modal-body paddingB0"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="$ctrl.organization.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.nameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group" show-errors><label class="control-label" for="businessName-input" translate>entities._all.businessName</label> <input id="businessName-input" name="businessNameInput" ng-model="$ctrl.organization.businessName" translate-attr="::{placeholder: \'entities._all.businessName\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.businessNameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group"><label class="control-label" for="address-input" translate>entities._all.address</label> <input id="address-input" name="addressInput" translate-attr="::{placeholder: \'entities._all.address\'}" ng-model="$ctrl.organization.address" class="form-control input-sm"></div><div class="form-group"><label class="control-label" translate>entities._all.country</label><div class="select2-sm"><ui-select ng-model="$ctrl.organization.countryId" theme="select2"><ui-select-match placeholder="{{\'entities._all.country\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="country.id as country in $ctrl.countries | filter: {name: $select.search}"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" for="description-input" translate>entities._all.description</label> <textarea id="description-input" name="descriptionInput" ng-model="$ctrl.organization.description" class="form-control input-sm"></textarea></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="$ctrl.saveOrganization()" translate>buttons.save</button></div></form><div style="position: relative; height: 400px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
      controller: OrganizationEditController,
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function OrganizationEditController ($scope, Admin, Var, utils) {
    let vm = this;

    vm.$onInit = function onInit () {
      vm.organization = angular.copy(vm.resolve.organization);
      vm.countries = vm.resolve.countries;

      vm.saveOrganization = saveOrganization;
    };

    function saveOrganization () {
      if (!vm.updateForm.$valid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      Var
        .prototype$patchAttributes({
          id: vm.organization.id
        }, {
          name: vm.organization.name,
          businessName: vm.organization.businessName,
          address: vm.organization.address,
          description: vm.organization.description,
          countryId: vm.organization.countryId
        })
        .$promise
        .then(response => {
          vm.modalInstance.close(response);
        })
        .catch(err => {
          console.log(err);
          vm.saveError = utils.getHTTPError(err);
        });
    }

  }
})();
